define(function(require){
    'use strict';

    var _ = require('underscore');
    var Handlebars = require('handlebars');
    var I18n       = require('utils/i18n');
    var NumFormat  = require('system/libs/num_format');


    /**
     * Хелпер для интернационализации
     * @param  {String}     Ключ для поиска перевода
     * @return {string}     Найденный перевод в словаре
     * @author  Aleksandr Vasilenko <info@acset.ru>
     */
    Handlebars.registerHelper('I18n', function(str){
        var args; (args = _.compact(arguments));
        if(args.length > 1){
            args.pop();
        }
        return (typeof(I18n) != 'undefined' ? I18n.t.apply(null, args) : str);
    });





    /**
     * Хелпер для форматирования цен
     * @param  {int}        Цена
     * @return {string}     Форматированную цену с валютой
     * @author Aleksandr Vasilenko <info@acset.ru>
     */



function updatePriceHelper() {
   console.log('Текущий символ:');

    Handlebars.registerHelper('PRICE', function(price, symbol) {
        var sym;
        if (window.innerWidth < 700) {
            sym = 'Пополнить баланс';
        } else {
            sym = (typeof symbol === 'boolean') ? ' <i class="fa fa-rub"></i>' : ' руб.';
        }
        var result = '<span class="price">' + NumFormat(parseFloat(price).toFixed(2)) + '</span>' + sym;

        return new Handlebars.SafeString(result);
    });
}

// Первоначальный вызов функции
updatePriceHelper();

// Добавление обработчика события изменения размера окна
window.addEventListener('resize', updatePriceHelper);







    /**
     * Хелпер для форматирования чисел
     * @param  {int}        Число
     * @return {string}     Форматированное число
     * @author  Aleksandr Vasilenko <info@acset.ru>
     */
    Handlebars.registerHelper('NUM', function(num) {
        return NumFormat(num);
    });

    /**
     * Хелпер для склонения существительных
     * @param  {int}        Число
     * @param  {str}        Ключ для поиска в словаре I18n
     * @return {str}        Число с существительным
     * @author Aleksandr Vasilenko <info@acset.ru>
     */
    Handlebars.registerHelper('PLURAL', function(num, key){
        var number = Math.abs(num);
        var plural = Handlebars.helpers.I18n(key);
        var result;
        if(number == 0){
            result = plural.five;
        }else{
            number %= 100;
            if (number >= 5 && number <= 20){
                result = plural.five;
            }else{
                number %= 10;
                if (number == 1){
                    result = plural.one;
                }else if(number >= 2 && number <= 4){
                    result = plural.two;
                }else{
                    result = plural.five;
                }
            }
        }
        return num + ' ' + result;
    });

    /**
     * Хелпер для получения падежа
     * @param  {int}        Число - индекс падежа (1 - именительный, 2 - родительный ...)
     * @param  {str}        Ключ для поиска в словаре I18n
     * @return {str}        Слово в нужном падеже
     *
     * Examples :
     *  week : {
     *       1 : 'неделя',
     *       2 : 'недели',
     *       3 : 'неделе',
     *       4 : 'неделю',
     *       5 : 'неделей',
     *       6 : 'неделе'
     *  },
     * @author Minin Vlad <mininvlad@gmail.com>
     */
    Handlebars.registerHelper('CASE', function(index, key){
        var word = Handlebars.helpers.I18n(key);
        return word[index];
    });

    /**
     *  Хелпер для сравнения двух параметров
     *  @param  {mixed}         Первый аргумент
     *  @param  {string}        Оператор сравнения, необязательный, по умолчанию "==="
     *  @param  {mixed}         Второй аргумент
     *  @return {bool}          Результат сравнения
     *
     *  Examples:
     *  {{#compare param1 [operator] param2}} ... {{/compare}}
     *
     *  {{#compare param1 param2}}      => (param1 === param2)
     *  {{#compare param1 "!=" param2}} => (param1 != param2)
     */
    Handlebars.registerHelper('compare', function(leftValue, operator, rightValue, options){
        var operators, result;

        if(arguments.length < 3){
            throw new Error('Handlebars Helper \'compare\' needs 2 parameters');
        }

        if(options === undefined){
            options     = rightValue;
            rightValue  = operator;
            operator    = '==';
        }

        operators = {
            '=='    : function(l, r){return l == r;},
            '==='   : function(l, r){return l === r; },
            '!='    : function(l, r){return l != r;},
            '!=='   : function(l, r){return l !== r;},
            '<'     : function(l, r){return l < r;},
            '>'     : function(l, r){return l > r;},
            '<='    : function(l, r){return l <= r;},
            '>='    : function(l, r){return l >= r;},
            'typeof': function(l, r){return typeof l == r;}
        };

        if(!operators[operator]){
            throw new Error('Handlebars Helper \'compare\' doesn\'t know operator '+operator);
        }

        result = operators[operator](leftValue, rightValue);
        if(result){
            return options.fn(this);
        }else{
            return options.inverse(this);
        }
    });

    /*
    *   Helper basic loop
    */
    Handlebars.registerHelper('repeat', function(n, block){
        var accum = '';
        for(var i = 0; i < n; ++i)
            accum += block.fn(i);
        return accum;
    });

    /*
    *   Helper basic loop with from to values
    */
    Handlebars.registerHelper('for', function(from, to, block) {
        var accum = '';
        for(var i = from; i < to; i ++)
            accum += block.fn(i);
        return accum;
    });

    Handlebars.registerHelper("plus", function(value, plusValue, options) {
        return parseInt(value) + plusValue;
    });

    Handlebars.registerHelper("minus", function(value, plusValue, options) {
        return parseInt(value) - plusValue;
    });

    Handlebars.registerHelper("multiply", function(value, multiplyValue, options) {
        return parseInt(value) * multiplyValue;
    });

    Handlebars.registerHelper('TOFIXED', function(num, digits){
        return (num || 0).toFixed(digits);
    });

    Handlebars.registerHelper('messengerDisplayValue', function(type, value) {
        if (type == 6) {
            var data = this.data;
            if (data && data.user_id) {
                return data.user_id + ' (бот: ' + (data.bot_name || data.bot_id || '') + ')';
            }
        }
        return value;
    });
});
